import React from 'react';

const SvgExport = (props) => (
  <svg width={12} height={13} {...props}>
    <path
      fill="#FFF"
      stroke="#FFF"
      strokeLinecap="square"
      strokeLinejoin="bevel"
      strokeWidth={0.2}
      d="M3.052 4.08a.187.187 0 0 1 0-.266l2.797-2.76A.191.191 0 0 1 5.994 1a.191.191 0 0 1 .144.054l2.797 2.76a.187.187 0 0 1 0 .266l-.77.76a.193.193 0 0 1-.27 0L6.73 3.69v4.683a.19.19 0 0 1-.19.188H5.45a.19.19 0 0 1-.19-.188V3.689l-1.167 1.15a.193.193 0 0 1-.27 0l-.77-.759zm7.894 2.857c-.043-.047-.097-.047-.097-.047H8.404v1.282h1.284v3.384H2.3V8.172h1.284V6.89H1.146s-.06 0-.108.05C1 6.982 1 7.038 1 7.038v5.637c0 .09.074.164.166.164h9.654a.168.168 0 0 0 .168-.166V7.024s0-.042-.042-.087z"
    />
  </svg>
);

export default SvgExport;
